import React, { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";

import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";

import { Box, Typography } from "@material-ui/core";
import { Pagination } from "@material-ui/lab";

import TestsRequests from "services/tests";

import CoinManagementTableHeading from "./CoinsMangementTableHeading";
import CoinManagementTableItem from "./CoinManagementTableItem";

const CoinManagementTable = ({ searchMode, searchInput }) => {
  const dispatch = useDispatch();
  const { coins, coinsCurrentPage, coinsTotalPage } = useSelector(
    ({ tests }) => tests
  );

  useEffect(() => {
    if (searchMode) {
      dispatch(TestsRequests.getCoins(1, searchInput));
    } else {
      dispatch(TestsRequests.getCoins(1));
    }
  }, [searchInput, searchMode]);

  const handleChangePagination = (_, value) => {
    if (searchMode) {
      dispatch(TestsRequests.getCoins(value, searchInput));
    } else {
      dispatch(TestsRequests.getCoins(value));
    }
  };

  return (
    <div className="Cmt-table-responsive">
      {coins &&
        (coins.length === 0 ? (
          <Box
            display={"flex"}
            justifyContent={"center"}
            paddingTop={"30px"}
            paddingBottom={"20px"}
          >
            <Typography variant="h3">موردی برای نمایش وجود ندارد</Typography>
          </Box>
        ) : (
          <Table>
            <TableHead>
              <CoinManagementTableHeading />
            </TableHead>
            <TableBody>
              {coins.map((item) => (
                <CoinManagementTableItem
                  data={item}
                  key={item._id}
                  id={item._id}
                />
              ))}
            </TableBody>
          </Table>
        ))}
      {coins.length !== 0 ? (
        <Box display={"flex"} justifyContent={"center"} marginTop={"20px"}>
          <Pagination
            count={coinsTotalPage}
            color="primary"
            page={coinsCurrentPage}
            onChange={handleChangePagination}
          />
        </Box>
      ) : null}
    </div>
  );
};

export default CoinManagementTable;